import React from 'react';

import classes from './NutritionSection.module.scss';
import { ModalInputBox } from '../../../../shared/components/modals';

type NutritionSectionProps = {
  protein: number;
  carbs: number;
  fats: number;
};

const NutritionSection = ({ protein, carbs, fats }: NutritionSectionProps) => {
  const nutritionItems = [
    { label: 'Proteins:', value: protein },
    { label: 'Carbs:', value: carbs },
    { label: 'Fats:', value: fats },
  ];

  return (
    <ModalInputBox>
      <div className={classes.nutritionBox}>
        {nutritionItems.map((item) => (
          <div className={classes.nutritionItem} key={item.label}>
            <span className={classes.label}>{item.label}</span>
            <span className={classes.value}>{item.value}</span>
          </div>
        ))}
      </div>
      <div className={classes.alert}>
        ***Double check Compliance and Trends before making changes to the macro plan.
      </div>
    </ModalInputBox>
  );
};

export { NutritionSection };
